// extracted by mini-css-extract-plugin
export default {"loadingHolder":"MyComponentLoading_loadingHolder__W8rlP","loading":"MyComponentLoading_loading__YW4GN","pulse":"MyComponentLoading_pulse__N6vtB"};